import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const ArrowsOutward = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 24 24" ref={ref} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
        <path d="m680-280-56-56 103-104H520v-80h207L624-624l56-56 200 200-200 200Zm-400 0L80-480l200-200 56 56-103 104h207v80H233l103 104-56 56Z" />
      </svg>
    </SvgIcon>
  );
});

ArrowsOutward.displayName = "ArrowsOutward";

export default ArrowsOutward;
